"use strict";

define('components/fileuploader',['components/ajax', 'components/document_upload'], function(ajax, document_upload) {
    var fileUploader = {
        init: function(formComponent, formNode) {
            formNode.find('.file_upload_field').each(function() {
                var field = $(this);
                var file_select = field.find('.file_select');
                var file_drop = field.find('.file_drop');
                if (!file_select[0] || !file_drop[0]) return;
                var file_selection = field.find('.file_selection');
                var is_multiple = file_select.attr('multiple');
                var accept = file_select.attr('accept');

                file_select.off('.file_upload_field');
                file_select.on('change.file_upload_field', function(e) {
                    $('.progress').removeAttr('hidden');
                    file_drop.removeClass('active');

                    var files = file_select[0].files;
                    var file =  files && files[0];
                    if (!file) {
                        file_selection.attr('value', '');
                    } else if (fileUploader.isFilesizeExceeded(file)) {
                        fileUploader.showFilesizeExceededError(field);
                        file_selection.attr('value', '');

                        if (!is_multiple) {
                            fileUploader.clearFileInput(file_select);
                        }
                    } else {
                        fileUploader.handleFileSelected(formNode, files, field, file_select, file_selection,
                                                        is_multiple);
                    }
                    return false;
                });

                file_drop.off('.file_upload_field');
                var drag_events = ['dragover.file_upload_field',
                                   'dragleave.file_upload_field',
                                   'dragenter.file_upload_field'].join(' ')
                file_drop.on(drag_events, function(e) {
                    file_drop.toggleClass('active', e.type == 'dragover');
                    return false;
                });


                file_drop.on('drop.file_upload_field', function(e) {
                    $('.progress').removeAttr('hidden');
                    file_drop.removeClass('active');
                    var files = e.originalEvent.dataTransfer.files;
                    file_select.data('dragdrop_files', files);
                    var file =  files && files[0];
                    if (!file) {
                        file_selection.attr('value', '');
                    } else if (fileUploader.isFilesizeExceeded(file)) {
                        fileUploader.showFilesizeExceededError(field);
                        file_selection.attr('value', '');
                        file_select.data('dragdrop_files', []);
                    } else if (accept && !accept.toLowerCase().includes(file.type.toLowerCase())) {		// TODO: Is there a better way to check? E.g. what if accept contains a wildcard, e.g. "image/*"?
                        fileUploader.showFileError(field, "Invalid file type.");
                    } else {
                        fileUploader.handleFileSelected(formNode, files, field, file_select, file_selection,
                                                        is_multiple);
                    }
                    return false;
                });
            });
        },
        getFileSelectorNode: function(field) {
            // file-selector only exists on some forms.
            return field.closest('.file-selector');
        },
        getErrorMessageNode: function(field) {
            return field.find('.error-message');
        },
        isFilesizeExceeded: function(file) {
            // Enforce a 300mb file size limit since chrome/spdy does not return the
            // http error 413 via the ajax error callback (in components/form.js)
            return file.size > 1024*1024*300;
        },
        showFileError: function(field, message) {
            fileUploader.getFileSelectorNode(field).addClass('has-error');
            fileUploader.getErrorMessageNode(field).text(message);
        },
        showFilesizeExceededError: function(field) {
            this.showFileError(field, "The file you selected exceeds our file size limit of 300MB.  Please try a smaller file.");
        },
        clearFileInput: function(file_input) {
            // Clears the file input by creating a temporary form and calling reset();
            // replace with a placeholder to ensure we do not create nested forms.
            // See http://stackoverflow.com/questions/1043957/clearing-input-type-file-using-jquery
            var placeholder = $('<span></span>');
            file_input.replaceWith(placeholder);
            var temp_form = $('<form></form>').append(file_input);
            temp_form[0].reset();
            placeholder.replaceWith(file_input);
        },
        handleFileSelected: function(formNode, files, field, file_select, file_selection, is_multiple) {
            fileUploader.getFileSelectorNode(field).removeClass('has-error');
            fileUploader.getErrorMessageNode(field).text('');

            if (!is_multiple) {
                file_selection.attr('value', files[0].name);
            }

            if (file_select.data('auto-upload') == '1') {
                formNode.trigger('jsq:documentUploadStarted', [files]);
                fileUploader.uploadFiles(formNode, files);
            } else {
                formNode.trigger('jsq:fileSelect', [files]);
            }
        },
        
        // NOTE: Not yet refactored to handle non-DocumentModel uploads.
        uploadFiles: function(formNode, files) {
            document_upload.uploadDocuments(formNode, files);
        }
    };

    return fileUploader;
});   


